import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = {
  key: 0,
  class: "absolute inset-0 bg-light opacity-50 z-10"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons-outlined font-thin",
  style: {"color":"#1b1b1f","margin-bottom":"-1px"}
}, " file_download ", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons-outlined font-thin",
  style: {"color":"#1b1b1f","margin-bottom":"-1px"}
}, " file_download ", -1)
const _hoisted_6 = [
  _hoisted_5
]

import { watch } from "vue";
import { onMounted, onUnmounted, ref, shallowRef } from "vue";
import React from "react";
import { render } from "react-dom";
import {
	Excalidraw,
	WelcomeScreen,
	exportToBlob,
	exportToCanvas,
	elementsOverlappingBBox,
	getCommonBounds,
	isElementInsideBBox,
	elementPartiallyOverlapsWithOrContainsBBox,
	useDevice,
} from "@excalidraw/excalidraw";

import type { ExcalidrawImperativeAPI } from "@excalidraw/excalidraw/types";
import { debounce } from "lodash";
import { ExcalidrawElement } from "@excalidraw/excalidraw/types/element/types";
import { getTranslatedString as _ } from "../../i18n";
import { isEqual } from "lodash";
import Btn from "./Btn.vue";
import Tooltip from "./Tooltip.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'DrawEditor',
  props: {
    initialData: null,
    disabled: { type: Boolean }
  },
  emits: ["onChange", "apiReady"],
  setup(__props: any, { emit }) {

const props = __props as {
	initialData: { elements: ExcalidrawElement[]; files: Record<string, string> };
	disabled?: boolean;
};




const excalidraw = shallowRef(null);
const excalidrawAPI = ref<null | ExcalidrawImperativeAPI>(null);
const root = ref(null);

const currentData = ref<{
	elements: ExcalidrawElement[];
	files: Record<string, string>;
	image?: string;
}>({ elements: [], files: {} });

const onChange = debounce(async (elements, state, files) => {
	// check if the update is an actual change
	if (
		isEqual(Object.keys(currentData.value.files), Object.keys(files)) &&
		elements.every(el =>
			isEqual(
				el,
				currentData.value.elements.find(e => e.id === el.id),
			),
		)
	) {
		return; // no change
	}

	currentData.value = JSON.parse(
		JSON.stringify({
			elements,
			files,
		}),
	);

	const blob = await exportToBlob({
		elements,
		files,
		mimeType: "image/png",
	});

	const imageAsBase64 = await new Promise<string>(resolve => {
		const reader = new FileReader();
		reader.onload = () => {
			resolve(reader.result as string);
		};
		reader.readAsDataURL(blob);
	});

	emit("onChange", {
		elements,
		files,
		image: imageAsBase64,
	});
}, 1000);

onMounted(async () => {
	currentData.value = JSON.parse(
		JSON.stringify({
			elements: props.initialData.elements,
			files: props.initialData.files,
		}),
	);

	const excalidrawElement = React.createElement(
		Excalidraw,
		{
			onChange,
			initialData: props.initialData,
			excalidrawAPI: (api: ExcalidrawImperativeAPI) => {
				excalidrawAPI.value = api;
			},
			UIOptions: {
				tools: {
					image: true,
				},
			},
			langCode: "it-IT",
		},
		React.createElement(
			WelcomeScreen,
			null,
			React.createElement(
				WelcomeScreen.Center,
				null,
				React.createElement(
					WelcomeScreen.Center.Heading,
					null,
					_("draw.welcome_screen_heading"),
				),
			),
			React.createElement(
				WelcomeScreen.Hints.ToolbarHint,
				null,

				React.createElement(
					"p",
					{
						style: {
							"font-size": "15px",
							width: "350px",
							"margin-top": "50px !important",
						},
					},
					React.createElement("span", null, _("draw.welcome_screen_hint_toolbar_1")),
					React.createElement(
						"svg",
						{
							"aria-hidden": "true",
							focusable: "false",
							viewBox: "0 0 20 20",
							class: "",
							fill: "none",
							stroke: "currentColor",
							"stroke-linecap": "round",
							"stroke-linejoin": "round",
							width: "20px",
							height: "20px",
							style: {
								width: "20px",
								height: "20px",
							},
						},
						React.createElement(
							"g",
							{ "stroke-width": "1.25" },
							React.createElement("path", { d: "M12.5 6.667h.01" }),
							React.createElement("path", {
								d: "M4.91 2.625h10.18a2.284 2.284 0 0 1 2.285 2.284v10.182a2.284 2.284 0 0 1-2.284 2.284H4.909a2.284 2.284 0 0 1-2.284-2.284V4.909a2.284 2.284 0 0 1 2.284-2.284Z",
							}),
							React.createElement("path", {
								d: "m3.333 12.5 3.334-3.333c.773-.745 1.726-.745 2.5 0l4.166 4.166",
							}),
							React.createElement("path", {
								d: "m11.667 11.667.833-.834c.774-.744 1.726-.744 2.5 0l1.667 1.667",
							}),
						),
					),
					React.createElement("span", null, _("draw.welcome_screen_hint_toolbar_2")),
				),
			),
		),
	);

	await new Promise(resolve => setTimeout(resolve, 500));
	root.value = render(excalidrawElement, excalidraw.value);

	emit("apiReady", {
		api: excalidrawAPI,
		exportToBlob,
		exportToCanvas,
		elementsOverlappingBBox,
		getCommonBounds,
		isElementInsideBBox,
		elementPartiallyOverlapsWithOrContainsBBox,
		useDevice,
	});
});
onUnmounted(() => {
	if (root.value) {
		root.value.unmount();
	}
});

const downloadAsImage = async () => {
	if (!excalidrawAPI.value) return;

	const blob = await exportToBlob({
		elements: excalidrawAPI.value.getSceneElements(),
		files: excalidrawAPI.value.getFiles(),
		mimeType: "image/png",
	});

	const link = document.createElement("a");
	link.href = URL.createObjectURL(blob);
	link.download = `evo-whiteboard-${new Date().toDateString()}.png`;
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
};

watch(
	() => props.disabled,
	disabled => {
		if (excalidrawAPI.value) {
			excalidrawAPI.value.updateScene({
				appState: {
					readOnly: disabled,
				},
			});
		}
	},
	{
		immediate: true,
	},
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref_key: "excalidraw",
      ref: excalidraw,
      class: "excalidraw hide-in-thumbnail"
    }, _toDisplayString(_ctx.$t("misc.loading")), 513),
    (props.disabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true),
    _createVNode(Tooltip, {
      textValue: 'Scarica lavagna',
      placement: 'bottom',
      class: "absolute z-20 cursor-pointer hover:bg-gray-200 lg:block hidden",
      style: {"left":"14.9rem","bottom":"1rem","border-radius":"0.5rem !important"}
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "px-2 pt-1.5",
          onClick: downloadAsImage,
          style: {"background":"#f2f2f6","border-radius":"0.5rem !important"}
        }, _hoisted_4)
      ]),
      _: 1
    }),
    _createVNode(Tooltip, {
      textValue: 'Scarica lavagna',
      placement: 'bottom',
      class: "absolute z-20 cursor-pointer hover:bg-gray-200 block lg:hidden transform -translate-x-1/2",
      style: {"left":"50%","bottom":"1.2rem","border-radius":"0.5rem !important"}
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          onClick: downloadAsImage,
          class: "px-2 pt-1.5",
          style: {"background":"#f2f2f6","border-radius":"0.5rem !important"}
        }, _hoisted_6)
      ]),
      _: 1
    })
  ]))
}
}

})